import type { ReceiptLocalePreferenceDTO } from './accountTypes.js';
import {
  isReceiptLocaleCode,
  serverEffectiveDefaultLocale as serverEffectiveDefaultLocaleFromPreference,
  type ReceiptLocaleCode,
} from './receiptLocalePreference.js';

export function isDefaultReceiptPreference(
  data: ReceiptLocalePreferenceDTO | undefined,
): boolean {
  if (data === undefined) {
    return true;
  }
  if (data.mode === 'custom') {
    return false;
  }
  return data.mode === 'default' || data.isPlatformDefault;
}

/** True when Default must PUT live UI language (null/stale stored uiLocale). */
export function needsReceiptUiLocaleSync(
  storedUiLocale: string | null | undefined,
  liveUiLocale: ReceiptLocaleCode,
): boolean {
  if (!isReceiptLocaleCode(storedUiLocale ?? undefined)) {
    return true;
  }
  return storedUiLocale !== liveUiLocale;
}

/** Coalesce in-flight sync: always keep the latest requested locale. */
export function nextCoalescedLocale(
  _pending: ReceiptLocaleCode | null,
  incoming: ReceiptLocaleCode,
): ReceiptLocaleCode {
  return incoming;
}

/** Re-export generation-aligned Default locale helper. */
export const serverEffectiveDefaultLocale = serverEffectiveDefaultLocaleFromPreference;
